import { IFilter, ResponsibleType } from '@shared/interfaces';

export const userFilters: Array<IFilter[] | IFilter> = [
    /*	[
		{ value: null, placeholder: 'generic.filter.allStatus', selected: true, searchFor: 'active' },
		{ value: true, placeholder: 'generic.filter.activeUsers', selected: false, searchFor: 'active' },
		{ value: false, placeholder: 'generic.filter.inactiveUsers', selected: false, searchFor: 'active' },
	],*/
    [
        { value: null, placeholder: 'generic.filter.allRoles', selected: true, searchFor: 'userRole' },
        { value: 'admin', placeholder: 'generic.filter.admins', selected: false, searchFor: 'userRole' },
        { value: 'standard', placeholder: 'generic.filter.standardUsers', selected: false, searchFor: 'userRole' }
    ],
    /*	[
			{ value: null, placeholder: 'generic.filter.allCert', selected: true, searchFor: 'certificateExpiring' },
			{ value: true, placeholder: 'generic.filter.certificateExpiring', selected: false, searchFor: 'certificateExpiring' },
			{ value: false, placeholder: 'generic.filter.certificateOk', selected: false, searchFor: 'certificateExpiring' },
		],*/
    [
        { value: null, placeholder: 'generic.filter.none', selected: true, groupBy: 'order' },
        { value: 'department', placeholder: 'users.item.department', selected: false, groupBy: 'userData.department' }
    ]
    /*{ placeholder: 'generic.filter.certificateExpiration', sortBy: 'certificateExpiration' },*/
];

export const responsibleFilters: IFilter[] = [
    { placeholder: 'generic.filter.all', selected: true, value: null, searchFor: 'responsibleType' },
    { placeholder: 'generic.filter.sag', selected: false, value: ResponsibleType.sag, searchFor: 'responsibleType' },
    { placeholder: 'generic.filter.rc', selected: false, value: ResponsibleType.rc, searchFor: 'responsibleType' }
];
